<template>
  <div
    class="flex min-h-[min(320px,33vh)] flex-col items-center justify-center rounded-xl border border-dashed border-gray-300/80 bg-gray-50 px-8 py-14 text-center dark:border-white/15 dark:bg-white/[0.02]"
  >
    <div
      class="mb-5 flex h-16 w-16 items-center justify-center rounded-2xl border border-gray-200 bg-white text-[color:var(--v-primary-base)] shadow-sm dark:border-white/10 dark:bg-white/5 dark:shadow-none"
    >
      <icon id="magnify" size="2.25rem" class="opacity-90"/>
    </div>
    <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-200">Results will appear here</h3>
    <p class="mt-2 max-w-md text-sm leading-relaxed text-gray-600 dark:text-gray-400">
      Configure databases and composition on the left panel, then run
      <span class="font-medium text-gray-800 dark:text-gray-300">Start Prediction</span>
      to explore casting properties and compare alloys in this area.
    </p>
  </div>
</template>

<script>
export default {
  name: "PredixCastingResultsPlaceholder",
};
</script>
